import.meta.rspackNonce = "__CSP_NONCE__";